
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'data-privacy-request-ui',
  currentProjectVersion: 'static-1.5420',
  depVersions: {
  "data-privacy-request-ui": "static-1.5420",
  "data-fetching-client": "static-1.9570",
  "head-dlb": "static-1.4921",
  "history": "static-4.47",
  "hs-test-utils": "static-1.7906",
  "hub-http-shared-msw-handlers": "static-1.9718",
  "hubspot-dlb": "static-2.1828",
  "HubStyleTokens": "static-2.11346",
  "I18n": "static-7.1600",
  "jasmine-runner": "static-1.6364",
  "privacy-center-public-service-types": "static-1.4683",
  "quartz": "static-1.6861",
  "react-dlb": "static-1.76",
  "react-router-dom": "static-5.26",
  "ui-components-test-utils": "static-1.5484",
  "UIComponents": "static-3.8293",
  "webpack-env": "static-1.54",
  "apollo-stack-hubspot": "static-3.84",
  "foundations-assets": "static-1.4742",
  "foundations-components": "static-1.7711",
  "foundations-components-test-utils": "static-1.5194",
  "foundations-theming": "static-1.4307",
  "hub-http": "static-1.6113",
  "quartz-config": "static-1.639",
  "quartz-core": "static-1.6080",
  "quick-fetch": "static-1.3829",
  "raven": "static-3.5808",
  "react": "static-7.184",
  "react-rhumb": "static-1.16549",
  "SharedI18nStrings": "static-1.181",
  "ui-addon-i18n": "static-1.11042",
  "usage-tracker": "static-1.7231",
  "usage-tracker-anonymous": "static-1.5648",
  "usage-tracker-core": "static-1.7081",
  "enviro": "static-4.425",
  "hs-promise-rejection-tracking": "static-1.5473",
  "PortalIdParser": "static-2.386",
  "raven-hubspot": "static-1.6115",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "hubspot-url-utils": "static-1.4034",
  "immutable": "static-2.76",
  "metrics-js": "static-1.9522",
  "react-redux": "static-7.69",
  "redux": "static-4.16",
  "styled-components": "static-2.87",
  "bend-plugin-trellis-migration": "static-1.3320",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3138",
  "quartz-webpack": "static-1.3085",
  "fast-json-stable-stringify": "static-1.4",
  "graphql": "static-1.80",
  "HeadJS": "static-2.734",
  "framer-motion": "static-1.70",
  "hs-test-utils-bend-plugin": "static-1.3017",
  "msw": "static-1.39",
  "testing-library": "static-1.150",
  "ts-schema": "static-1.3992",
  "i18n-data": "static-1.219",
  "moment-timezone": "static-5.81",
  "react-utils": "static-2.5262",
  "StyleGuideUI": "static-3.485",
  "jasmine": "static-4.4219",
  "rpc-client-utils": "static-1.4538",
  "HubStyle": "static-2.11654",
  "ui-addon-draggable": "static-3.4664",
  "cssUtils": "static-1.766",
  "hs-story-utils": "static-1.9324",
  "icons": "static-2.639",
  "react-select-plus": "static-1.65",
  "react-virtualized": "static-2.97",
  "ui-images": "static-2.1127",
  "bend-plugin-foundations-components": "static-1.3980",
  "floating-ui": "static-1.54",
  "foundations-theming-specialty": "static-1.2023",
  "react-aria": "static-1.64",
  "tanstack-table": "static-1.53",
  "trellis-assets": "static-1.1519",
  "ui-fonts": "static-1.608",
  "foundations-components-legacy": "static-1.736",
  "bend-plugin-foundations-theming": "static-1.2790",
  "foundations-theming-base": "static-1.3292",
  "stylex": "static-1.30",
  "dispatcher": "static-1.134",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.818",
  "hubspotter-http": "static-1.4566",
  "mobile-manifest-mixins": "static-1.508",
  "module-federation": "static-1.21",
  "quartz-auth": "static-1.536",
  "quartz-head": "static-1.526",
  "quartz-i18n": "static-1.536",
  "quartz-routing": "static-1.291",
  "quartz-test": "static-1.536",
  "quartz-tracking": "static-1.240",
  "usage-tracker-container": "static-1.7221",
  "csstype": "static-1.50",
  "react-input-autosize": "static-2.17",
  "bender-build-tools": "static-1.3062",
  "chirp-fetch": "static-1.1776",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "react-flip-move": "static-1.68",
  "sassPrefix": "static-1.153",
  "hubspotter-http-shared-msw-handlers": "static-1.9716",
  "usage-tracker-session-replay": "static-1.4917",
  "amplitude-session-replay-browser": "static-1.58"
},
  depPathPrefixes: {
  "data-privacy-request-ui": "/data-privacy-request-ui/static-1.5420",
  "data-fetching-client": "/data-fetching-client/static-1.9570",
  "head-dlb": "/head-dlb/static-1.4921",
  "history": "/history/static-4.47",
  "hs-test-utils": "/hs-test-utils/static-1.7906",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9718",
  "hubspot-dlb": "/hubspot-dlb/static-2.1828",
  "HubStyleTokens": "/HubStyleTokens/static-2.11346",
  "I18n": "/I18n/static-7.1600",
  "jasmine-runner": "/jasmine-runner/static-1.6364",
  "privacy-center-public-service-types": "/privacy-center-public-service-types/static-1.4683",
  "quartz": "/quartz/static-1.6861",
  "react-dlb": "/react-dlb/static-1.76",
  "react-router-dom": "/react-router-dom/static-5.26",
  "ui-components-test-utils": "/ui-components-test-utils/static-1.5484",
  "UIComponents": "/UIComponents/static-3.8293",
  "webpack-env": "/webpack-env/static-1.54",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.84",
  "foundations-assets": "/foundations-assets/static-1.4742",
  "foundations-components": "/foundations-components/static-1.7711",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5194",
  "foundations-theming": "/foundations-theming/static-1.4307",
  "hub-http": "/hub-http/static-1.6113",
  "quartz-config": "/quartz-config/static-1.639",
  "quartz-core": "/quartz-core/static-1.6080",
  "quick-fetch": "/quick-fetch/static-1.3829",
  "raven": "/raven/static-3.5808",
  "react": "/react/static-7.184",
  "react-rhumb": "/react-rhumb/static-1.16549",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.181",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11042",
  "usage-tracker": "/usage-tracker/static-1.7231",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5648",
  "usage-tracker-core": "/usage-tracker-core/static-1.7081",
  "enviro": "/enviro/static-4.425",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5473",
  "PortalIdParser": "/PortalIdParser/static-2.386",
  "raven-hubspot": "/raven-hubspot/static-1.6115",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4034",
  "immutable": "/immutable/static-2.76",
  "metrics-js": "/metrics-js/static-1.9522",
  "react-redux": "/react-redux/static-7.69",
  "redux": "/redux/static-4.16",
  "styled-components": "/styled-components/static-2.87",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3320",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3138",
  "quartz-webpack": "/quartz-webpack/static-1.3085",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "graphql": "/graphql/static-1.80",
  "HeadJS": "/HeadJS/static-2.734",
  "framer-motion": "/framer-motion/static-1.70",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3017",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.150",
  "ts-schema": "/ts-schema/static-1.3992",
  "i18n-data": "/i18n-data/static-1.219",
  "moment-timezone": "/moment-timezone/static-5.81",
  "react-utils": "/react-utils/static-2.5262",
  "StyleGuideUI": "/StyleGuideUI/static-3.485",
  "jasmine": "/jasmine/static-4.4219",
  "rpc-client-utils": "/rpc-client-utils/static-1.4538",
  "HubStyle": "/HubStyle/static-2.11654",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4664",
  "cssUtils": "/cssUtils/static-1.766",
  "hs-story-utils": "/hs-story-utils/static-1.9324",
  "icons": "/icons/static-2.639",
  "react-select-plus": "/react-select-plus/static-1.65",
  "react-virtualized": "/react-virtualized/static-2.97",
  "ui-images": "/ui-images/static-2.1127",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3980",
  "floating-ui": "/floating-ui/static-1.54",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2023",
  "react-aria": "/react-aria/static-1.64",
  "tanstack-table": "/tanstack-table/static-1.53",
  "trellis-assets": "/trellis-assets/static-1.1519",
  "ui-fonts": "/ui-fonts/static-1.608",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.736",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2790",
  "foundations-theming-base": "/foundations-theming-base/static-1.3292",
  "stylex": "/stylex/static-1.30",
  "dispatcher": "/dispatcher/static-1.134",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.818",
  "hubspotter-http": "/hubspotter-http/static-1.4566",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.508",
  "module-federation": "/module-federation/static-1.21",
  "quartz-auth": "/quartz-auth/static-1.536",
  "quartz-head": "/quartz-head/static-1.526",
  "quartz-i18n": "/quartz-i18n/static-1.536",
  "quartz-routing": "/quartz-routing/static-1.291",
  "quartz-test": "/quartz-test/static-1.536",
  "quartz-tracking": "/quartz-tracking/static-1.240",
  "usage-tracker-container": "/usage-tracker-container/static-1.7221",
  "csstype": "/csstype/static-1.50",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "bender-build-tools": "/bender-build-tools/static-1.3062",
  "chirp-fetch": "/chirp-fetch/static-1.1776",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "react-flip-move": "/react-flip-move/static-1.68",
  "sassPrefix": "/sassPrefix/static-1.153",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9716",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4917",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.58"
}
};
